import { InjectionToken, ModuleWithProviders, NgModule } from "@angular/core";
import { NotifyService } from "@timeghost/web-api";
import { SignalrService } from "./signalr.service";

const noopComponentToken = new InjectionToken<{}>("SIGNALR_NOOP_COMPONENT");
@NgModule()
export class SignalrModule {
	static forRoot(): ModuleWithProviders<SignalrModule> {
		return {
			ngModule: SignalrModule,
			providers: [
				SignalrService,
				{ provide: NotifyService, useExisting: SignalrService },
				{
					provide: noopComponentToken,
					useFactory: (signalrService: SignalrService) => {
						// Inline component logic for initialization after app init
						// This factory creates a noop object that, when created, will initialize SignalrService.
						signalrService.initialize();
						return {};
					},
					deps: [SignalrService],
				},
			],
		};
	}
}
